import { put, takeLatest } from 'redux-saga/effects';
import { SCA_VERIFY_RECIPIENT_REDIRECT_PARAMS } from '../constants';
import { scaSyncRecipient, scaVerifyRedirectFailure } from '../actions';
import { getStoredRid } from '../logic/sca';

function* scaVerifyRecipientRedirectSaga(action) {
  const { controlStatus, rid: fromUrl } = action.payload || {};
  const rid = (fromUrl || getStoredRid() || '').trim();
  const status = typeof controlStatus === 'string' ? controlStatus.trim().toUpperCase() : null;

  if (!rid) {
    yield put(scaVerifyRedirectFailure({ message: 'Missing recipient id', result: { controlStatus } }));
    return;
  }

  if (status && status !== 'VALIDATED') {
    // Not fatal: we can still poll; webhook may arrive anyway
    yield put(scaVerifyRedirectFailure({
      message: 'Verification not completed. You can resume.',
      result: { controlStatus: status, rid },
    }));
  }

  yield put(scaSyncRecipient({ rid }));
}

export function* watchSCAVerifyRecipientRedirect() {
  yield takeLatest(SCA_VERIFY_RECIPIENT_REDIRECT_PARAMS, scaVerifyRecipientRedirectSaga);
}

export default [
  watchSCAVerifyRecipientRedirect(),
];
